class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9998 2L11.4498 11.22L1.27979 12.69L8.63979 19.87L6.89979 30L15.9998 25.22L25.0998 30L23.3598 19.87L30.7198 12.7L20.5498 11.22L15.9998 2Z" fill="#16191D"></path></svg>';
  }
}
const e = "pwc-icon-star--filled";
customElements.get(e) || customElements.define(e, t);
